import '../css/reset.css';
import '../css/common.css';
import '../../components/utils/firebaseAnalytics';
import {
  requestPOST,
  OLD_API_URL,
  isApp,
  clearLocalStorageItem,
  getClientID,
  getInfoOfDeviceOS,
  getJWTToken,
  originCommunityURL,
} from './common-es6';

const btnLogin = document.getElementById('btnLogin');

const headerListCounseling = document.getElementsByClassName('header-list__counseling')[0];
const headerListTest = document.getElementsByClassName('header-list__test')[0];
const headerListMedicine = document.getElementsByClassName('header-list__medicine')[0];

const btnNavCounselingHead = document.getElementsByClassName('header-list__counseling-title')[0];
const btnNavSearch = document.getElementById('btnNavSearch');
const btnNavOfflineCenter = document.getElementById('btnNavOfflineCenter');
const btnNavCounseling = document.getElementById('btnNavCounseling');

const btnNavTestHead = document.getElementsByClassName('header-list__test-title')[0];
const btnNavTestsPsychological = document.getElementById('btnNavTestsPsychological');
const btnNavTestsPersonality = document.getElementById('btnNavTestsPersonality');
const btnNavTestsDepressive = document.getElementById('btnNavTestsDepressive');
const btnNavTestsDepressiveType = document.getElementById('btnNavTestsDepressiveType');
const btnNavTestsSelfEsteem = document.getElementById('btnNavTestsSelfEsteem');
const btnNavTestsWorkStress = document.getElementById('btnNavTestsWorkStress');
const btnNavTestsPrePareWorkStress = document.getElementById('btnNavTestsPrePareWorkStress');
const btnNavTestsMBTIWithDepressive = document.getElementById('btnNavTestsMBTIWithDepressive');
const btnNavTestsCovidWithDepressive = document.getElementById('btnNavTestsCovidWithDepressive');
const btnNavTestsPanicDisorder = document.getElementById('btnNavTestsPanicDisorder');

const btnNavMedicineHead = document.getElementsByClassName('header-list__medicine-title')[0];
const btnNavMedicineSearch = document.getElementById('btnNavMedicineSearch');
const btnNavMedicineTest = document.getElementById('btnNavMedicineTest');
const btnNavMentalCenter = document.getElementById('btnNavMentalCenter');

const btnNavBusinessHead = document.getElementsByClassName('header-list__business-title')[0];
const btnNavCommunityHead = document.getElementsByClassName('header-list__community-title')[0];

const btnProfileLogout = document.getElementById('btnProfileLogout');
const headerSearchForm = document.getElementById('headerSearchForm');
const headerSearchInput = document.getElementById('headerSearchInput');
const headerSearchIcon = document.getElementById('headerSearchIcon');

const btnNavCounselingPartner = document.getElementById('btnNavCounselingPartner');
const btnNavNotice = document.getElementById('btnNavNotice');
const btnNavManual = document.getElementById('btnNavManual');
const btnNavMypage = document.getElementById('btnNavMypage');
const userIdNav = document.getElementById('userIdNav');
const userIdNavDropDown = document.getElementById('userIdNavDropDown');
const btnNavs = document.getElementsByClassName('js-nav');
const btnNavPageRefresh = document.getElementById('btnNavPageRefresh');
const headerMobileNavBtn = document.getElementsByClassName('header-mobile__nav-btn')[0];
const headerMobileNavDim = document.getElementsByClassName('header-mobile__nav-dim')[0];
const headerMobileTitle = document.getElementsByClassName('header-mobile__title')[0];

const headerMobileNavList = document.getElementsByClassName('header-mobile__nav-list')[0];
const mobileNavCommunity = document.getElementsByClassName('mobile-nav__community-title')[0];
const mobileNavQuoteBible = document.getElementsByClassName('mobile-nav__quote-bible-title')[0];
const mobileNavCounseling = document.getElementsByClassName('mobile-nav__counseling-title')[0];
const mobileNavTest = document.getElementsByClassName('mobile-nav__test-title')[0];
const mobileNavMedicine = document.getElementsByClassName('mobile-nav__medicine-title')[0];

const mobileLowerList = document.getElementsByClassName('mobile-lower-list');
const mobileNavUserData = document.getElementsByClassName('mobile-nav__user-data')[0];
const mobileNavList = document.getElementsByClassName('js-mobile__nav-list');
const mobileNavSign = document.getElementsByClassName('mobile-nav__sign')[0];

const url = window.location.href;
const locationUrl = window.location.origin;

const deviceOS = getInfoOfDeviceOS();
const clientID = getClientID();

const mobileMenuList = [
  {
    menuTitle: '상담사 찾기',
    menuUrl: '/counselor',
  },
  {
    menuTitle: '상담센터 찾기',
    menuUrl: '/counseling-centers',
  },
  {
    menuTitle: '상담하기',
    menuUrl: 'https://trost.onelink.me/F1Cv/05zw2po0',
    menuEffect: 'rel="noopener"',
  },
  {
    menuTitle: '랜선 선배와 고민상담',
    redirectURL: 'https://mentaltalk.trost.co.kr/',
    searchURL: 'https://mentaltalk.trost.co.kr/',
  },
  {
    menuTitle: '자기분석 테스트',
    menuUrl: '/service/test/',
  },
  {
    menuTitle: '복용약 찾기',
    menuUrl: '/service/medicine/',
  },
  {
    menuTitle: '약물 의존도 자가체크',
    menuUrl: '/service/test/medicine/',
  },
  {
    menuTitle: '마음관리 이야기',
    menuUrl: '/mobile/contents/',
  },
  // {
  //   menuTitle: '부부관계 코칭상담',
  //   menuUrl: '/promotion/marriageTherapy/',
  // },
  // {
  //   menuTitle: '연인관계 코칭상담',
  //   menuUrl: '/promotion/coupleTherapy/',
  // },
  // {
  //   menuTitle: '심리주치의',
  //   menuUrl: '/promotion/therapySpecialist/',
  // },
  {
    menuTitle: '단체 기업용 복지 프로그램',
    // menuUrl: '/business/',
    menuUrl: 'https://trosteap.co.kr/?utm_source=trostweb&utm_medium=organic&utm_content=mobile_menu',
    // searchURL: '/business/',
    searchURL: 'https://trosteap.co.kr/?utm_source=trostweb&utm_medium=organic&utm_content=mobile_menu',
  },
  {
    menuTitle: '질문 보기',
    menuUrl: '/service/mentaltalk/poll/search/',
  },
  {
    menuTitle: '참여하기',
    menuUrl: '/service/mentaltalk/poll/',
  },
  {
    menuTitle: '결과 보기',
    menuUrl: '/service/mentaltalk/poll/search/',
  },
  // {
  //   menuTitle: '연인관계 코칭상담',
  //   menuUrl: '/promotion/coupleTherapy/',
  //   searchURL: '/promotion/coupleTherapy/',
  // },
];

let clickMenuScrollTop = 0;

window.clickMenuScrollTop = clickMenuScrollTop;

// 심리검사 항목 기본값 (API 실패 시 폴백)
const defaultPsychTestItems = [
  { menuTitle: '심리검사', redirectURL: '/test/psychological/', searchURL: '/test/psychological/' },
  { menuTitle: '성격검사', redirectURL: '/test/personality/', searchURL: '/test/personality/' },
  { menuTitle: '우울증 검사', redirectURL: '/test/depressive-check-program/', searchURL: '/test/depressive-check-program/' },
  { menuTitle: '자존감 검사', redirectURL: '/test/self-esteem-program/', searchURL: '/test/self-esteem-program/' },
  { menuTitle: '직무스트레스 검사', redirectURL: '/test/work-stress/', searchURL: '/test/work-stress/' },
  { menuTitle: '취업 스트레스 검사', redirectURL: '/test/prepare-work-stress/', searchURL: '/test/prepare-work-stress/' },
  { menuTitle: 'MBTI 우울증 검사', redirectURL: '/test/mbti-with-depressive/', searchURL: '/test/mbti-with-depressive/' },
  { menuTitle: '코로나 우울증 검사', redirectURL: '/test/covid-19-with-depressive/', searchURL: '/test/covid-19-with-depressive/' },
  { menuTitle: '우울 유형 검사', redirectURL: '/test/depressive-type-check/', searchURL: '/test/depressive-type-check/' },
  { menuTitle: '공황 증상 자가점검', redirectURL: '/test/panic-disorder/', searchURL: '/test/panic-disorder/' },
];

// 모바일 웹 메뉴 세팅
const serverPsychTestItems = window.psychTestItems;
const psychTestItems = (Array.isArray(serverPsychTestItems) && serverPsychTestItems.length > 0)
  ? serverPsychTestItems
  : defaultPsychTestItems;

const mobileNavListLink = [
  {
    menuTitle: '상담사 찾기',
    redirectURL: '/counselor',
    searchURL: '/counselor',
  },
  {
    menuTitle: '상담센터 찾기',
    redirectURL: '/counseling-centers',
    searchURL: '/counseling-centers',
  },
  {
    menuTitle: '상담하기',
    redirectURL: 'https://trost.onelink.me/F1Cv/05zw2po0',
    searchURL: 'https://trost.onelink.me/F1Cv/05zw2po0',
    menuEffect: 'rel="noopener"',
  },
  ...psychTestItems,
  {
    menuTitle: '정신과 약 정보',
    redirectURL: '/medicine',
    searchURL: '/medicine',
  },
  {
    menuTitle: '복용약 찾기',
    redirectURL: '/service/medicine/',
    searchURL: '/service/medicine/',
  },
  {
    menuTitle: '약물 의존도 자가체크',
    redirectURL: '/service/test/medicine/',
    searchURL: '/service/test/medicine/',
  },
  {
    menuTitle: '정신의학과 찾기',
    redirectURL: '/service/offline/mobile/#age=&type=mentalHospital,&keyword=',
    searchURL: '/service/offline/mobile/',
  },
  {
    menuTitle: '마음관리 이야기',
    redirectURL: '/mobile/contents/',
    searchURL: '/mobile/contents/',
  },
  // {
  //   menuTitle: '부부관계 코칭상담',
  //   redirectURL: '/promotion/marriageTherapy/',
  //   searchURL: '/promotion/marriageTherapy/',
  // },
  // {
  //   menuTitle: '연인관계 코칭상담',
  //   redirectURL: '/promotion/coupleTherapy/',
  //   searchURL: '/promotion/coupleTherapy/',
  // },
  // {
  //   menuTitle: '심리주치의',
  //   redirectURL: '/promotion/therapySpecialist/',
  //   searchURL: '/promotion/therapySpecialist/',
  // },
  {
    menuTitle: '단체 기업용 복지 프로그램',
    // redirectURL: '/business/',
    redirectURL: 'https://trosteap.co.kr/?utm_source=trostweb&utm_medium=organic&utm_content=mobile_menu',
    // searchURL: '/business/',
    searchURL: 'https://trosteap.co.kr/?utm_source=trostweb&utm_medium=organic&utm_content=mobile_menu',
  },
  {
    menuTitle: '질문 보기',
    menuUrl: '/service/mentaltalk/poll/search/',
  },
  {
    menuTitle: '참여하기',
    menuUrl: '/service/mentaltalk/poll/',
  },
  {
    menuTitle: '결과 보기',
    menuUrl: '/service/mentaltalk/poll/search/',
  },
  // {
  //   menuTitle: '연인관계 코칭상담',
  //   menuUrl: '/promotion/coupleTherapy/',
  //   redirectURL: '/promotion/coupleTherapy/',
  //   searchURL: '/promotion/coupleTherapy/',
  // },
];

const setNavigationDisplayActive = () => {
  // PC 웹 메뉴 세팅
  if (
    url.indexOf('/service/offline/') !== -1
      && window.location.hash.indexOf('mentalHospital') === -1
  ) {
    if (btnNavCounselingHead) btnNavCounselingHead.classList.add('is-active');
    if (btnNavOfflineCenter) btnNavOfflineCenter.classList.add('is-active');
  } else if (
    url.indexOf('/service/offline/') !== -1
      && window.location.hash.indexOf('mentalHospital') !== -1
  ) {
    if (btnNavMedicineHead) btnNavMedicineHead.classList.add('is-active');
    if (btnNavMentalCenter) btnNavMentalCenter.classList.add('is-active');
  } else if (url === `${locationUrl}/service/offline/detailPage.php`) {
    if (btnNavCounselingHead) btnNavCounselingHead.classList.add('is-active');
    if (btnNavOfflineCenter) btnNavOfflineCenter.classList.add('is-active');
  }

  if (
    url === `${locationUrl}/service/partner/`
      || url.indexOf('/service/partner/counseling/?no=') !== -1
  ) {
    if (btnNavCounselingPartner) btnNavCounselingPartner.classList.add('is-active');
  } else if (
    url === `${locationUrl}/service/counseling/`
      || url.indexOf('/service/counseling/texttime/?no=') !== -1
  ) {
    if (btnNavCounseling) btnNavCounseling.classList.add('is-active');
  } else if (url === `${locationUrl}/service/partner/notice/`) {
    if (btnNavNotice) btnNavNotice.classList.add('is-active');
  } else if (
    url === `${locationUrl}/service/search/partner/`
      || url.indexOf(`${locationUrl}/service/search/partner/profile/`) !== -1
      || url.indexOf(`${locationUrl}/service/search/partner/profile/payment/`) !== -1
  ) {
    if (btnNavSearch) btnNavSearch.classList.add('is-active');
    if (btnNavCounselingHead) btnNavCounselingHead.classList.add('is-active');
  } else if (
    url === `${locationUrl}/service/partner/mypage/`
      || url === `${locationUrl}/service/partner/mypage/activity/`
      || url === `${locationUrl}/service/partner/mypage/private/`
      || url === `${locationUrl}/service/partner/mypage/profile/`
      || url === `${locationUrl}/service/partner/mypage/counseling/`
      || url === `${locationUrl}/service/partner/mypage/matching/`
      || url === `${locationUrl}/service/partner/mypage/payment/`
      || url === `${locationUrl}/service/partner/mypage/schedule/`
      || url === `${locationUrl}/service/partner/mypage/review/`
      || url === `${locationUrl}/service/partner/mypage/paymentHistory/`
      || url === `${locationUrl}/service/partner/mypage/history/`
      || url === `${locationUrl}/service/partner/mypage/product/`
  ) {
    if (btnNavMypage) btnNavMypage.classList.add('is-active');
  } else if (url === `${locationUrl}/manual/texttime/`) {
    if (btnNavManual) btnNavManual.classList.add('is-active');
  } else if (url === `${locationUrl}/service/test/`) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/service/test/psychological/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsPsychological) btnNavTestsPsychological.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/service/test/personality/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsPersonality) btnNavTestsPersonality.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/service/medicine/`) !== -1) {
    if (btnNavMedicineHead) btnNavMedicineHead.classList.add('is-active');
    if (btnNavMedicineSearch) btnNavMedicineSearch.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/service/test/medicine/`) !== -1) {
    if (btnNavMedicineHead) btnNavMedicineHead.classList.add('is-active');
    if (btnNavMedicineTest) btnNavMedicineTest.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/promotion/channel/depressive-check-program/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsDepressive) btnNavTestsDepressive.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/promotion/channel/depressive-type-check/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsDepressiveType) btnNavTestsDepressiveType.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/promotion/channel/self-esteem-program/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsSelfEsteem) btnNavTestsSelfEsteem.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/promotion/channel/work-stress/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsWorkStress) btnNavTestsWorkStress.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/promotion/channel/prepare-work-stress/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsPrePareWorkStress) btnNavTestsPrePareWorkStress.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/promotion/channel/mbti-with-depressive/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsMBTIWithDepressive) btnNavTestsMBTIWithDepressive.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/promotion/channel/covid-19-with-depressive/`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsCovidWithDepressive) btnNavTestsCovidWithDepressive.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/service/test/panic-disorder`) !== -1) {
    if (btnNavTestHead) btnNavTestHead.classList.add('is-active');
    if (btnNavTestsPanicDisorder) btnNavTestsPanicDisorder.classList.add('is-active');
  } else if (url.indexOf(`${locationUrl}/business/`) !== -1) {
    if (btnNavBusinessHead) btnNavBusinessHead.classList.add('is-active');
  }
};

// 상담사 인증 상태 조회
const getPartnerStatus = () => {
  if (localStorage.userID && getJWTToken('accessToken')) {
    if ((JSON.parse(localStorage.userID).data.userID) && (JSON.parse(localStorage.userID).data.status === 'partner')) {
      // console.log('상담사 인증 상태 조회 localStorage가 있다.');
      // 상담사로 로그인이 되어 있는 경우
      requestPOST(`${OLD_API_URL}/partners/profile/`, {
        type: 'profile',
        partnerID: JSON.parse(localStorage.userID).data.userID,
      }, (status, resData) => {
        if (!status) {
          alert("잘못된 접근 입니다, 이용에 어려움이 있으시면 카카오톡 플러스친구 '@휴마트컴퍼니' 로 문의 주세요!");
          window.location.href = '/auth/sign_out.php';
          clearLocalStorageItem('auth');
          clearLocalStorageItem('userID');
          return false;
        }

        // 승인처리 중인 경우
        if ((resData.data.modifyHistory === null) || ((resData.data.modifyHistory) && (resData.data.modifyHistory.is_checked === '0')) || ((resData.data.modifyHistory) && (resData.data.modifyHistory.ppuh_disapproved_reason !== null))) {
          if (window.location.href.indexOf('auth/partner') === -1) {
            window.location.href = '/auth/partner/result/';
          }

          for (let i = 0; i < btnNavs.length; i += 1) {
            btnNavs[i].onclick = (e) => {
              // 승인되지 않은 상담사의 다른 페이지 접근 차단
              e.preventDefault();

              window.location.href = '/auth/partner/result/';
            };
          }

          // 승인이 된 경우
        } else if ((resData.data.modifyHistory.is_checked === '1') && (!resData.data.modifyHistory.ppuh_disapproved_reason || resData.data.modifyHistory.ppuh_disapproved_reason === '')) {
          setNavigationDisplayActive();
        }
      });
    }
  }
};

const setSignIn = () => {
  const redirectUri = window.location.href || '/';
  const moveSignIn = () => (deviceOS === 'web' ? document.getElementById('btnLogin').click() : window.location.href = `/mobile/sign/?redirectUri=${redirectUri}`);
  clearLocalStorageItem('loadPage');

  return moveSignIn();
};

const setSignUp = () => {
  const redirectUri = window.location.href || '/';
  const moveSignIn = () => (deviceOS === 'web' ? document.getElementById('btnLogin').click() : window.location.href = `/mobile/sign/signUp/?type=email&redirectUri=${redirectUri}`);
  clearLocalStorageItem('loadPage');

  return moveSignIn();
};

// 인기 검색어 슬라이더 설정
const SWIPER_CONFIG = {
  INTERVAL_TIME: 2000,
  TRANSITION_TIME: 300,
  ITEM_HEIGHT: 30,
};

// 인기 검색어 슬라이더 초기화 및 관리
const initPopularKeywordSlider = () => {
  const slider = document.getElementById('popularKeywordSlider');
  const sliderOpenButton = document.getElementById('popularKeywordSliderOpenButton');
  const sliderOpened = document.getElementById('popularKeywordSliderOpened');
  const keywordItems = document.querySelectorAll('#popularKeywordList .slider-content-item');

  if (!slider || !keywordItems.length) return;

  let activeIndex = 0;
  let sliderInterval;
  let sliderTrack = null;

  const initSliderTrack = () => {
    const originalItem = slider.querySelector('.slider-item');
    if (!originalItem) return;

    // 기존 slider-item을 감싸는 트랙 컨테이너 생성
    const track = document.createElement('div');
    track.className = 'slider-track';
    track.style.cssText = `
      display: flex;
      flex-direction: column;
      height: 100%;
      width: fit-content;
      max-width: 176px;
      margin: 0 auto;
      transition: transform ${SWIPER_CONFIG.TRANSITION_TIME}ms ease;
    `;

    slider.removeChild(originalItem);

    // 슬라이더를 위한 데이터 복제
    const sliderData = Array.from(keywordItems);
    const duplicatedData = [...sliderData, ...sliderData];

    duplicatedData.forEach((item) => {
      const sliderItem = document.createElement('div');
      sliderItem.className = 'slider-item';
      sliderItem.style.cssText = `
        min-height: ${SWIPER_CONFIG.ITEM_HEIGHT}px;
        height: ${SWIPER_CONFIG.ITEM_HEIGHT}px;
        display: flex;
        align-items: center;
        padding: 2px 0;
        cursor: pointer;
      `;

      sliderItem.innerHTML = `
        <p class="slider-item-ranking">${item.dataset.rank}</p>
        <img class="slider-item-icon" src="${item.dataset.imagePath}" alt="popular search keyword Icon" width="26" height="18" />
        <p class="slider-item-text">${item.dataset.keyword}</p>
      `;

      // slider-item 클릭 이벤트 추가
      sliderItem.addEventListener('click', () => {
        const { keyword } = item.dataset;
        window.location.href = `/search/result?keyword=${keyword}`;
      });

      track.appendChild(sliderItem);
    });

    const chevronIcon = slider.querySelector('.slider-chevron-icon');
    slider.insertBefore(track, chevronIcon);
    sliderTrack = track;
  };

  // 슬라이더 위치 업데이트
  const updateSliderPosition = (index) => {
    if (!sliderTrack) return;

    const originalDataLength = keywordItems.length;

    // 마지막 다음 → 순간적으로 리셋
    if (index === originalDataLength + 1) {
      sliderTrack.style.transition = 'none';
      sliderTrack.style.transform = 'translateY(0px)';

      // 다음 frame에서 자연스럽게 이어가기
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          sliderTrack.style.transition = `transform ${SWIPER_CONFIG.TRANSITION_TIME}ms ease`;
          sliderTrack.style.transform = `translateY(-${SWIPER_CONFIG.ITEM_HEIGHT}px)`;
          activeIndex = 1; // 상태 리셋
        });
      });

      return;
    }

    // 다음 슬라이드로 넘어가는 동작
    sliderTrack.style.transition = `transform ${SWIPER_CONFIG.TRANSITION_TIME}ms ease`;
    sliderTrack.style.transform = `translateY(-${SWIPER_CONFIG.ITEM_HEIGHT * index}px)`;
  };

  const startSlider = () => {
    if (sliderInterval) clearInterval(sliderInterval);

    sliderInterval = setInterval(() => {
      activeIndex += 1;
      updateSliderPosition(activeIndex);
    }, SWIPER_CONFIG.INTERVAL_TIME + SWIPER_CONFIG.TRANSITION_TIME);
  };

  const stopSlider = () => {
    if (sliderInterval) {
      clearInterval(sliderInterval);
      sliderInterval = null;
    }
  };

  const closeSlider = () => {
    sliderOpened.style.display = 'none';
    startSlider();
  };

  const handleOutsideClick = (e) => {
    if (sliderOpened.style.display === 'block' && !sliderOpened.contains(e.target) && !slider.contains(e.target)) {
      closeSlider();
      document.removeEventListener('click', handleOutsideClick);
    }
  };

  const openSlider = () => {
    sliderOpened.style.display = 'block';
    const currentTime = '09:00'; // 9시로 고정
    sliderOpened.querySelector('.slider-title-time').innerText = `${currentTime} 기준`;
    stopSlider();

    // 바깥 영역 클릭 시 닫기
    setTimeout(() => {
      document.addEventListener('click', handleOutsideClick);
    }, 0);
  };

  if (slider) {
    sliderOpenButton.addEventListener('click', openSlider);
  }

  const closeBtn = sliderOpened?.querySelector('.slider-title-wrapper');
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      closeSlider();
      document.removeEventListener('click', handleOutsideClick);
    });
  }

  keywordItems.forEach((item) => {
    item.addEventListener('click', () => {
      const { keyword } = item.dataset;

      window.location.href = `/search/result?keyword=${keyword}`;
      closeSlider(); // 클릭 후 닫기
    });
  });

  // 슬라이더 트랙 초기화 및 시작
  initSliderTrack();
  startSlider();

  window.addEventListener('beforeunload', stopSlider);
};

window.addEventListener('DOMContentLoaded', () => {
  if (isApp) {
    // 상단 여백 수동 조정
    if (window.location.pathname.indexOf('/service/medicine/') === -1) {
      document.getElementsByClassName('main')[0]?.style.setProperty('margin-top', '-48px', 'important');
    }

    document.getElementsByClassName('snsDiv')[0]?.style.setProperty('display', 'none', 'important');
  } else {
    // 헤더 노출
    if (document.getElementsByTagName('header')[0]?.classList.contains('is-hide')) {
      document.getElementsByTagName('header')[0]?.classList.remove('is-hide');
    }

    // 푸터 노출
    if (document.getElementById('footer')) {
      document.getElementById('footer').style.display = 'block';
    }
  }

  if (headerListCounseling) {
    headerListCounseling.addEventListener('mouseover', () => {
      document.getElementsByClassName('lower-list')[0].classList.add('lower-list__is-hover');

      headerListCounseling.addEventListener('mouseout', () => {
        document.getElementsByClassName('lower-list')[0].classList.remove('lower-list__is-hover');
      });
    });
  }

  if (headerListTest) {
    headerListTest.addEventListener('mouseover', () => {
      document.getElementsByClassName('lower-list')[1].classList.add('lower-list__is-hover');

      headerListTest.addEventListener('mouseout', () => {
        document.getElementsByClassName('lower-list')[1].classList.remove('lower-list__is-hover');
      });
    });
  }

  if (headerListMedicine) {
    headerListMedicine.addEventListener('mouseover', () => {
      document.getElementsByClassName('lower-list')[2].classList.add('lower-list__is-hover');

      headerListMedicine.addEventListener('mouseout', () => {
        document.getElementsByClassName('lower-list')[2].classList.remove('lower-list__is-hover');
      });
    });
  }

  setNavigationDisplayActive();

  // 커뮤니티 링크 동적 설정
  btnNavCommunityHead?.addEventListener('click', (e) => {
    e.preventDefault();
    window.location.href = originCommunityURL;
  });

  // 상담하기 링크 동적 설정
  btnNavCounseling?.addEventListener('click', (e) => {
    e.preventDefault();
    if (clientID) {
      window.location.href = '/service/counseling/';
    } else {
      window.location.href = `/login?redirectUri=${window.location.origin}/service/counseling/`;
    }
  });

  // 로그인 버튼 누를 떄 redirectUri 적용
  if (btnLogin) {
    btnLogin.addEventListener('click', (e) => {
      e.preventDefault();
      clearLocalStorageItem('auth');
      clearLocalStorageItem('userID');
      clearLocalStorageItem('loadPage');

      window.location.href = `/login?redirectUri=${window.location.href}`;
    });
  }

  if (deviceOS === 'web') {
    getPartnerStatus();
  }

  // 인기 검색어 슬라이더 초기화
  initPopularKeywordSlider();

  if (deviceOS === 'web') {
    getPartnerStatus();
  }

  if (userIdNav) {
    userIdNav.addEventListener('click', () => {
      userIdNavDropDown.classList.contains('is-show') ? userIdNavDropDown.classList.remove('is-show') : userIdNavDropDown.classList.add('is-show');
    });
  }

  if (btnNavPageRefresh) {
    btnNavPageRefresh.addEventListener('click', () => {
      window.location.reload(true);
    });
  }

  if (deviceOS !== 'web' && !isApp) {
    if (mobileNavSign) mobileNavSign.innerHTML = clientID && localStorage.userName ? '<div class="sign-out__btn">로그아웃</div>' : '<div class="sign-up__btn">회원가입</div><div class="sign-in__btn">로그인</div>';

    headerMobileNavBtn?.addEventListener('click', () => {
      const header = document.querySelector('header');
      header?.classList.toggle('is-open');
      headerMobileNavDim.classList.toggle('is-open__nav-list-dim', !headerMobileNavDim.classList.contains('is-open__nav-list-dim'));
      headerMobileNavList.classList.toggle('is-open__nav-list', !headerMobileNavList.classList.contains('is-open__nav-list'));

      if (headerMobileNavList.classList.contains('is-open__nav-list')) {
        if (document.getElementById('appDownloadFloatingPopup')) document.getElementById('appDownloadFloatingPopup').style.zIndex = '99';

        clickMenuScrollTop = document.documentElement.scrollTop;
        document.documentElement.classList.add('is-disabled-scroll');
      } else {
        if (document.getElementById('appDownloadFloatingPopup')) document.getElementById('appDownloadFloatingPopup').style.zIndex = '99999';

        document.documentElement.classList.remove('is-disabled-scroll');
        window.scrollTop = clickMenuScrollTop;
      }
    });

    if (mobileNavUserData) mobileNavUserData.innerHTML = clientID && localStorage.userName ? `${localStorage.userName}님, 반갑습니다!` : '로그인을 해주세요';

    for (let i = 0; i < mobileNavList.length; i += 1) {
      // 모바일 웹 링크 => 메뉴 연동
      if (window.location.href.indexOf(mobileNavListLink[i].searchURL) !== -1) {
        headerMobileTitle.innerHTML = mobileNavListLink[i].menuTitle;
      }
    }

    if (headerMobileTitle) headerMobileTitle.innerHTML = (headerMobileTitle.innerHTML) ? headerMobileTitle.innerHTML : '트로스트';

    if (mobileNavUserData) {
      mobileNavUserData.addEventListener('click', () => {
        if (clientID && localStorage.userName) {
          return;
        }

        window.location.href = '/mobile/sign/';
      });
    }

    if (mobileNavCommunity) {
      mobileNavCommunity.addEventListener('click', () => {
        window.location.href = originCommunityURL;
      });
    }

    if (mobileNavQuoteBible) {
      mobileNavQuoteBible.addEventListener('click', () => {
        mobileLowerList[1].classList.remove('lower-mobile-list__is-click');
        mobileLowerList[2].classList.remove('lower-mobile-list__is-click');
        mobileLowerList[3].classList.remove('lower-mobile-list__is-click');

        mobileLowerList[0].classList.toggle('lower-mobile-list__is-click', !mobileLowerList[0].classList.contains('lower-mobile-list__is-click'));
        document.getElementsByClassName('mobile-nav__btn-icon')[0].src = mobileLowerList[0].classList.contains('lower-mobile-list__is-click') ? 'https://assets.trost.co.kr/images/service/medicine/btn_up.png' : 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[1].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[2].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[3].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
      });
    }

    if (mobileNavCounseling) {
      mobileNavCounseling.addEventListener('click', () => {
        mobileLowerList[0].classList.remove('lower-mobile-list__is-click');
        mobileLowerList[2].classList.remove('lower-mobile-list__is-click');
        mobileLowerList[3].classList.remove('lower-mobile-list__is-click');

        mobileLowerList[1].classList.toggle('lower-mobile-list__is-click', !mobileLowerList[1].classList.contains('lower-mobile-list__is-click'));
        document.getElementsByClassName('mobile-nav__btn-icon')[1].src = mobileLowerList[1].classList.contains('lower-mobile-list__is-click') ? 'https://assets.trost.co.kr/images/service/medicine/btn_up.png' : 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[0].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[2].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[3].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
      });
    }

    if (mobileNavTest) {
      mobileNavTest.addEventListener('click', () => {
        mobileLowerList[0].classList.remove('lower-mobile-list__is-click');
        mobileLowerList[1].classList.remove('lower-mobile-list__is-click');
        mobileLowerList[3].classList.remove('lower-mobile-list__is-click');

        mobileLowerList[2].classList.toggle('lower-mobile-list__is-click', !mobileLowerList[2].classList.contains('lower-mobile-list__is-click'));
        document.getElementsByClassName('mobile-nav__btn-icon')[2].src = mobileLowerList[2].classList.contains('lower-mobile-list__is-click') ? 'https://assets.trost.co.kr/images/service/medicine/btn_up.png' : 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[0].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[1].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[3].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
      });
    }

    if (mobileNavMedicine) {
      mobileNavMedicine.addEventListener('click', () => {
        mobileLowerList[0].classList.remove('lower-mobile-list__is-click');
        mobileLowerList[1].classList.remove('lower-mobile-list__is-click');
        mobileLowerList[2].classList.remove('lower-mobile-list__is-click');

        mobileLowerList[3].classList.toggle('lower-mobile-list__is-click', !mobileLowerList[3].classList.contains('lower-mobile-list__is-click'));
        document.getElementsByClassName('mobile-nav__btn-icon')[3].src = mobileLowerList[3].classList.contains('lower-mobile-list__is-click') ? 'https://assets.trost.co.kr/images/service/medicine/btn_up.png' : 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[0].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[1].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
        document.getElementsByClassName('mobile-nav__btn-icon')[2].src = 'https://assets.trost.co.kr/images/service/medicine/btn_down.png';
      });
    }
  }

  if (document.getElementsByClassName('sign-in__btn')[0]) {
    document.getElementsByClassName('sign-in__btn')[0].addEventListener('click', () => {
      setSignIn();
    });
  }

  if (document.getElementsByClassName('sign-up__btn')[0]) {
    document.getElementsByClassName('sign-up__btn')[0].addEventListener('click', () => {
      setSignUp();
    });
  }

  if (document.getElementsByClassName('sign-out__btn')[0]) {
    document.getElementsByClassName('sign-out__btn')[0].addEventListener('click', () => {
      window.location.replace('/auth/sign_out.php');
    });
  }

  if (btnProfileLogout) {
    btnProfileLogout.addEventListener('click', () => {
      window.location.href = '/auth/sign_out.php';
    });
  }

  if (headerSearchForm) {
    headerSearchForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const inputValue = headerSearchInput.value.trim();
      if (!inputValue) return;
      window.location.href = `/search/result?keyword=${inputValue}`;
    });
  }

  if (headerSearchIcon) {
    headerSearchIcon.addEventListener('click', () => {
      const inputValue = headerSearchInput.value.trim();
      if (!inputValue) return;

      window.location.href = `/search/result?keyword=${inputValue}`;
    });
  }

  if (headerMobileTitle) {
    if (window.location.href.indexOf('/mobile/partner/search/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[0].menuTitle;
    } else if (window.location.href.indexOf('/service/offline/mobile/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[1].menuTitle;
    } else if (window.location.href.indexOf('/service/test/medicine/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[6].menuTitle;
    } else if (window.location.href.indexOf('/service/test/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[4].menuTitle;
    } else if (window.location.href.indexOf('/service/medicine/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[5].menuTitle;
    } else if (window.location.href.indexOf('/mobile/contents/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[7].menuTitle;
    } else if (window.location.href.indexOf('/promotion/marriageTherapy/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[8].menuTitle;
    } else if (window.location.href.indexOf('/promotion/coupleTherapy/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[9].menuTitle;
    } else if (window.location.href.indexOf('/business/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[10].menuTitle;
    } else if (window.location.href.indexOf('/service/mentaltalk/poll/search/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[11].menuTitle;
    } else if (window.location.href.indexOf('/service/mentaltalk/poll/result/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[13].menuTitle;
    } else if (window.location.href.indexOf('/service/mentaltalk/poll/') !== -1) {
      headerMobileTitle.innerHTML = mobileMenuList[12].menuTitle;
    } else if (window.location.href.indexOf('/mobile') !== -1) {
      headerMobileTitle.innerHTML = '<div style="position: relative; height: 52px;"><button onclick="window.location.href=\'https://trost.onelink.me/F1Cv/05zw2po0\'" style="padding: 6px 10px 8px; background-color: #fff42e; color: black; border: none; border-radius: 8px; cursor: pointer; position: absolute; right: 50px; top: 10px;">앱 다운로드</button></div>';
    } else {
      headerMobileTitle.innerHTML = '트로스트';
    }
  }

  // if (window.location.href.indexOf('/service/test/') === -1) {
  if (document.getElementsByClassName('header-pc-wrap')[0]) document.getElementsByClassName('header-pc-wrap')[0].style.position = 'fixed';
  if (document.getElementsByClassName('header-mobile-wrap')[0]) document.getElementsByClassName('header-mobile-wrap')[0].style.position = 'fixed';
  // }

  if (deviceOS !== 'web') {
    if (headerMobileNavBtn) {
      window.addEventListener('click', (e) => {
        window.e = e;
        if (e.target !== headerMobileNavBtn
          && e.target !== headerMobileNavList
          && e.target.offsetParent !== headerMobileNavList
          && headerMobileNavList.classList.contains('is-open__nav-list')) {
          headerMobileNavBtn.click();
        }
      });
    }

    if (document.getElementById('downloadAppLinkMobile')) {
      document.getElementById('downloadAppLinkMobile').addEventListener('click', () => {
        window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0?fallback=https%3A%2F%2Fwww.trost.co.kr%2F';
      });
    }
  }

  if (navigator.userAgent.toLowerCase().indexOf('ipad') !== -1) {
    if (document.getElementsByTagName('header')[0]) document.getElementsByTagName('header')[0].style.height = '48px !important;';
    if (document.getElementsByClassName('header-mobile-wrap')[0]) document.getElementsByClassName('header-mobile-wrap')[0].style.display = 'block';
    if (document.getElementsByClassName('header-pc-wrap')[0]) document.getElementsByClassName('header-pc-wrap')[0].style.display = 'none';
    if (document.getElementsByClassName('header-logo')[0]) document.getElementsByClassName('header-logo')[0].classList.add('header-logo-in-mobile');
  } else if (document.getElementsByTagName('header')[0]) document.getElementsByTagName('header')[0].style.height = '72px !important;';

  //
  if (window.location.href.indexOf('/eap/') !== -1) {
    if (document.getElementsByClassName('header-pc__gnb')[0]) document.getElementsByClassName('header-pc__gnb')[0].style.display = 'none';
    if (document.getElementsByClassName('header-mobile__title')[0]) document.getElementsByClassName('header-mobile__title')[0].style.display = 'none';
    if (document.getElementsByClassName('header-mobile__nav-btn')[0]) document.getElementsByClassName('header-mobile__nav-btn')[0].style.display = 'none';
    if (document.getElementsByClassName('footer')[0]) document.getElementsByClassName('footer')[0].style.display = 'none';
  }
});
